import React, { PureComponent } from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Carousel from 'components/Carousel/Carousel';

import { ImageBlock } from './Styles/ImageBlock';
import { StyledGrid } from './Styles/StyledGrid';

const gallery = [
  {
    text: 'INSURANCE.OLD_INSURANCES_GALLERY.PAPERWORK.TITLE',
    altIntlKey: 'INSURANCE.OLD_INSURANCES_GALLERY.PAPERWORK.ALT_TEXT',
    srcSet: {
      xs: 'old-insurances-gallery/paperwork@mobile320.jpg',
      sm: 'old-insurances-gallery/paperwork@mobile480.jpg',
      md: 'old-insurances-gallery/paperwork@tablet768.jpg',
      lg: 'old-insurances-gallery/paperwork@desktop1024.jpg',
      xl: 'old-insurances-gallery/paperwork@desktop1366.jpg',
    },
  },
  {
    text: 'INSURANCE.OLD_INSURANCES_GALLERY.STAPLER.TITLE',
    altIntlKey: 'INSURANCE.OLD_INSURANCES_GALLERY.STAPLER.ALT_TEXT',
    srcSet: {
      xs: 'old-insurances-gallery/stapler@mobile320.jpg',
      sm: 'old-insurances-gallery/stapler@mobile480.jpg',
      md: 'old-insurances-gallery/stapler@tablet768.jpg',
      lg: 'old-insurances-gallery/stapler@desktop1024.jpg',
      xl: 'old-insurances-gallery/stapler@desktop1366.jpg',
    },
  },
  {
    text: 'INSURANCE.OLD_INSURANCES_GALLERY.PEN.TITLE',
    altIntlKey: 'INSURANCE.OLD_INSURANCES_GALLERY.PEN.ALT_TEXT',
    srcSet: {
      xs: 'old-insurances-gallery/pen@mobile320.jpg',
      sm: 'old-insurances-gallery/pen@mobile480.jpg',
      md: 'old-insurances-gallery/pen@tablet768.jpg',
      lg: 'old-insurances-gallery/pen@desktop1024.jpg',
      xl: 'old-insurances-gallery/pen@desktop1366.jpg',
    },
  },
  {
    text: 'INSURANCE.OLD_INSURANCES_GALLERY.CLIPS.TITLE',
    altIntlKey: 'INSURANCE.OLD_INSURANCES_GALLERY.CLIPS.ALT_TEXT',
    srcSet: {
      xs: 'old-insurances-gallery/clips@mobile320.jpg',
      sm: 'old-insurances-gallery/clips@mobile480.jpg',
      md: 'old-insurances-gallery/clips@tablet768.jpg',
      lg: 'old-insurances-gallery/clips@desktop1024.jpg',
      xl: 'old-insurances-gallery/clips@desktop1366.jpg',
    },
  },
];

class SectionOldInsurancesGallery extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
    };
  }

  handleChangeCarouselStep = step => {
    this.setState(() => ({
      currentStep: step,
    }));
  };

  render() {
    const { currentStep } = this.state;

    return (
      <StyledGrid
        col={{ xs: 12, lg: 6 }}
        offset={{ lg: 3 }}
        spacingHorizontal={{ xs: '6x', md: '40px', lg: '0' }}
      >
        <Carousel
          currentStep={currentStep}
          onStepChanged={this.handleChangeCarouselStep}
        >
          {gallery.map(image => (
            <div key={image.text}>
              <Typography
                intlKey={image.text}
                variant="title"
                marginBottom={{ sm: '8x', md: '12x' }}
                intlValues={{ br: <br /> }}
              />
              <ImageBlock
                srcSet={image.srcSet}
                altIntlKey={image.altIntlKey}
                loading="lazy"
                webp={false}
              />
            </div>
          ))}
        </Carousel>
      </StyledGrid>
    );
  }
}

export default SectionOldInsurancesGallery;
